import FuseLoading from '@fuse/core/FuseLoading';
import FuseUtils from '@fuse/utils';
import settingsConfig from 'app/configs/settingsConfig';
import { Navigate } from 'react-router-dom';
import adminConfig from '../main/admin/adminConfig';
import appsConfigs from '../main/apps/appsConfigs';
import hrConfigs from '../main/hr/hrConfig';
import SignInConfig from '../main/sign-in/SignInConfig';
import SignOutConfig from '../main/sign-out/SignOutConfig';
import HomeApp from '../main/apps/home/HomeApp';
import GreetingsConfig from '../main/greetings/GreetingsConfig';
import ContactsConfig from '../main/contacts/ContactsConfig';
import Page404Config from '../main/404/Page404Config';
import MandatoryDocumentConfig from '../main/mandatory-document/MandatoryDocumentConfig';
import Oauth2Config from '../main/oauth2/Oauth2Config';

const routeConfigs = [
  ...appsConfigs,
  ...hrConfigs,
  ...adminConfig,
  SignOutConfig,
  SignInConfig,
  GreetingsConfig,
  MandatoryDocumentConfig,
  ContactsConfig,
  Page404Config,
  Oauth2Config,
];

const routes = [
  ...FuseUtils.generateRoutesFromConfigs(routeConfigs, settingsConfig.defaultAuth),
  {
    path: '/',
    element: <HomeApp />,
    auth: settingsConfig.defaultAuth,
  },
  {
    path: 'loading',
    element: <FuseLoading />,
  },
  {
    path: '*',
    element: <Navigate to="404" />,
    auth: null,
  },
];

export default routes;
